// Restricted (c) Siemens Healthineers AG, 2025, All rights reserved.

import { Component, computed, input } from '@angular/core';

@Component({
  standalone: true,
  imports: [],
  selector: 'app-part-status-info',
  templateUrl: './part-status-info.component.html',
  styleUrl: './part-status-info.component.scss',
})
export class PartStatusInfoComponent {
  partStatus = input<string>('');

  status = computed(() => {
    let result = { klass: 'none', value: '-' };
    if (this.partStatus() && this.partStatus() !== '') {
      result = {
        klass: this.partStatus().toLocaleLowerCase(),
        value: this.partStatus(),
      };
    }

    return result;
  });
}
